"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireWildcard(require("react"));

var _styled = require("./styled");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

/**
 * a list of default email domains,
 * can be overriden in component props
 */
var DEFAULT_DOMAINS = ['mail.ru', 'yandex.ru', 'bk.ru', 'gmail.com', 'rambler.ru', 'ya.ru', 'list.ru', 'inbox.ru', 'icloud.com', 'yahoo.com'];
/**
 * handle clicks outside of the input wrapper
 *
 * @param {Object} ref parent container ref
 * @param {Function} fn state property setter function
 */

var useClickOutside = function useClickOutside(ref, fn) {
  var handleClickOutside = function handleClickOutside(e) {
    if (ref && !ref.contains(e.target)) {
      fn();
    }
  };

  (0, _react.useEffect)(function () {
    document.addEventListener('click', handleClickOutside);
    return function () {
      document.removeEventListener('click', handleClickOutside);
    };
  }, [fn]);
};
/**
 * Autocomplete addition for the input of email type
 *
 * @param {String} value current input value
 * @param {Object} parentRef input container ref
 * @param {Function} handleSelect exec function on option select
 * @param {Function} setNoBlurValidation toggle input validation on blur
 * @param {Array<String>} domains custom list of email domains
 */


var AutoComplete = function AutoComplete(_ref) {
  var _ref$value = _ref.value,
      value = _ref$value === void 0 ? '' : _ref$value,
      parentRef = _ref.parentRef,
      handleSelect = _ref.handleSelect,
      setNoBlurValidation = _ref.setNoBlurValidation,
      _ref$domains = _ref.domains,
      domains = _ref$domains === void 0 ? DEFAULT_DOMAINS : _ref$domains;

  var _useState = (0, _react.useState)(false),
      _useState2 = _slicedToArray(_useState, 2),
      show = _useState2[0],
      setShow = _useState2[1];

  var _useState3 = (0, _react.useState)([]),
      _useState4 = _slicedToArray(_useState3, 2),
      refs = _useState4[0],
      setRefs = _useState4[1];

  var _useState5 = (0, _react.useState)(-1),
      _useState6 = _slicedToArray(_useState5, 2),
      focus = _useState6[0],
      setFocus = _useState6[1];

  var _useMemo = (0, _react.useMemo)(function () {
    setShow(!!~value.indexOf('@'));
    setFocus(-1);
    return value.split('@');
  }, [value]),
      _useMemo2 = _slicedToArray(_useMemo, 2),
      name = _useMemo2[0],
      domain = _useMemo2[1];

  var onClickOutside = (0, _react.useCallback)(function () {
    show && handleSelect();
    setShow(false);
  }, [show]);
  /**
   * render auto completion list
   */

  var items = (0, _react.useMemo)(function () {
    var domainsFiltered = domain ? domains.filter(function (item) {
      return item.startsWith(domain);
    }) : domains;

    if (!name || !domainsFiltered.length || domainsFiltered.length === 1 && domainsFiltered[0] === domain) {
      setShow(false);
      return null;
    }

    var tempRefs = [];
    var mappedItems = domainsFiltered.map(function (item, index) {
      var completion = domain ? item.split(domain)[1] : item;
      return /*#__PURE__*/_react["default"].createElement(_styled.AutoCompleteItem, {
        focused: index === focus,
        key: "AutoCompleteItem-".concat(index),
        onClick: function onClick() {
          setShow(false);
          handleSelect(value + completion);
        },
        ref: function ref(el) {
          tempRefs.push(el);
        }
      }, /*#__PURE__*/_react["default"].createElement("strong", null, value), completion);
    });
    setRefs(tempRefs);
    return mappedItems;
  }, [name, domain, focus]);
  /**
   * handle external dependencies of current state
   */

  (0, _react.useEffect)(function () {
    setNoBlurValidation(show);
  }, [show]);
  /**
   * bind key actions
   * up: 38, down: 40, enter: 13
   */

  (0, _react.useEffect)(function () {
    var handleKeyDown = function handleKeyDown(e) {
      if (!show || !refs.length) {
        return;
      }

      var tempFocus = focus;

      switch (e.keyCode) {
        case 38:
          e.preventDefault();
          tempFocus = tempFocus - 1 < 0 ? refs.length - 1 : tempFocus - 1;
          setFocus(tempFocus);
          refs[tempFocus].scrollIntoView(false);
          break;

        case 40:
          e.preventDefault();
          tempFocus = tempFocus + 1 >= refs.length - 1 ? 0 : tempFocus + 1;
          setFocus(tempFocus);
          refs[tempFocus].scrollIntoView(false);
          break;

        case 13:
          if (focus !== -1) {
            handleSelect(refs[tempFocus].textContent);
            setShow(false);
            setFocus(-1);
          }

          break;
      }
    };

    if (parentRef) {
      parentRef.addEventListener('keydown', handleKeyDown);
      return function () {
        parentRef.removeEventListener('keydown', handleKeyDown);
      };
    }
  }, [parentRef, items, focus]);
  /**
   * bind click event listener
   */

  useClickOutside(parentRef, onClickOutside);
  return /*#__PURE__*/_react["default"].createElement(_styled.AutoCompleteContainer, {
    show: show
  }, items || /*#__PURE__*/_react["default"].createElement("div", null));
};

AutoComplete.propTypes = {
  value: _propTypes["default"].string,
  handleSelect: _propTypes["default"].func,
  setNoBlurValidation: _propTypes["default"].func,
  parentRef: _propTypes["default"].object,
  domains: _propTypes["default"].array
};
var _default = AutoComplete;
exports["default"] = _default;